import React from 'react';

const defaultProviderBrand = {
    displayName: 'Vert',
    websiteUrl: 'https://vert.works',
    badgeTheme: 'vert',
    badgeImageUrl: '/assets/images/provider-badge-vert.v1.svg'
};

export const resolveProviderBrand = (providerBrand, artworkOrigin) => {
    const displayName = typeof providerBrand?.displayName === 'string' ? providerBrand.displayName.trim() : '';
    const websiteUrl = typeof providerBrand?.websiteUrl === 'string' && /^https?:\/\//i.test(providerBrand.websiteUrl)
        ? providerBrand.websiteUrl : null;
    if (!displayName || !websiteUrl) return null;

    const assetPath = providerBrand.badgeImageUrl;
    const badgeImageUrl = typeof assetPath === 'string' && /^\/assets\/images\/[a-z0-9][a-z0-9._-]*\.svg$/i.test(assetPath) && artworkOrigin !== null
        ? `${artworkOrigin?.replace(/\/$/, '') || ''}${assetPath}` : null;
    return {displayName, websiteUrl, badgeTheme: providerBrand.badgeTheme, badgeImageUrl};
};

export default function BillingProviderBadge({providerBrand, artworkOrigin}) {
    const resolved = resolveProviderBrand(providerBrand, artworkOrigin) || resolveProviderBrand(defaultProviderBrand, artworkOrigin);

    return (
        <a href={resolved.websiteUrl} target="_blank" rel="noopener noreferrer"
           aria-label={`Learn more about ${resolved.displayName}`} data-provider-badge={resolved.badgeTheme}>
            {resolved.badgeImageUrl ? (
                <span aria-hidden="true" className="provider-badge-image inline-block h-8 w-[82px]" style={{
                    backgroundColor: 'var(--provider-badge-colour, var(--primary-button-text-colour, currentColor))',
                    maskImage: `url("${resolved.badgeImageUrl}")`,
                    WebkitMaskImage: `url("${resolved.badgeImageUrl}")`,
                    maskSize: 'contain', WebkitMaskSize: 'contain',
                    maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat'
                }}/>
            ) : (
                <span className="inline-flex h-8 items-center rounded border px-3 text-xs font-semibold">
                    Built with {resolved.displayName}
                </span>
            )}
        </a>
    );
}
